import { cn } from "@omni/utils/styles";

import { CreateOrEditAddressModal } from "@/components/Address/modals/CreateOrEditAddressModal/createOrEditAddressModal.component";
import { useAddressBook } from "@/components/Checkout/CheckoutCustomer/addresses/context/addressBook.context";
import { useAddresses } from "@/components/Checkout/CheckoutCustomer/addresses/hooks/useAddresses.hook";

type Props = {
    className?: string;
};

export const AddressFormModal = ({ className }: Props) => {
    const { addressId, type, addressFormOpen, change, onAddressFormClose } =
        useAddressBook();

    const { addresses } = useAddresses();

    const address = addresses.find(({ id }) => id === addressId);

    return (
        <CreateOrEditAddressModal
            address={address}
            type={type}
            skipValidation={false}
            open={addressFormOpen}
            className={cn(className)}
            setOpen={onAddressFormClose}
            onChange={change}
        />
    );
};
